'use client';
/** @jsxImportSource @emotion/react */

import type { FormGroupProps as MuiFormGroupProps } from '@mui/material/FormGroup';

import MuiFormGroup from '@mui/material/FormGroup';

type ExcludedMuiProps = '';

interface FormGroupProps extends Omit<MuiFormGroupProps, ExcludedMuiProps> {
  component?: React.ElementType;
}

export type { FormGroupProps };
export const FormGroup: React.FC<FormGroupProps> = MuiFormGroup;

FormGroup.displayName = 'FormGroup';
